import Flex from 'components/common/Flex';
import AppContext, { ChatContext } from 'context/Context';
import React, { useContext, memo, useState, useEffect } from 'react';
import { Card, Tab } from 'react-bootstrap';
import ChatContent from './content/ChatContent';
import ChatSidebar from './sidebar/ChatSidebar';
import './elvis.css';
import SearchModal from './SearchModal';
import ReportModal from './ReportModal';

const ChatTab = () => {
  const { threads, setCurrentThread, currentThread, setScrollToBottom } = useContext(ChatContext);
  const { config: { showElvis }, configDispatch } = useContext(AppContext);
  const [hideSidebar, setHideSidebar] = useState(false);
  const selectThread = thread => {
    setHideSidebar(false);
    setCurrentThread(thread);
    setScrollToBottom(true);
  };
  // Tab.Container hands back the pane index, which is only meaningful against the
  // threads array of this render - resolve it here and pass the object onwards.
  const handleSelect = e => selectThread(threads[parseInt(e)]);
  const threadIndex = threads.findIndex(x => x?.id === currentThread?.id);
  const activeKey = threadIndex < 0 ? 0 : threadIndex;

  useEffect(() => {
    // Hide the floating Elvis button while on this page, but never persist it -
    // closing the tab here would otherwise leave showElvis: false in localStorage.
    const prevShowElvis = showElvis;
    const setTransient = value =>
      configDispatch({
        type: 'SET_CONFIG',
        payload: { key: 'showElvis', value, setInStore: false }
      });
    setTransient(false);
    return () => setTransient(prevShowElvis);
  }, []);

  return (
    <>
      <Tab.Container
        id="left-tabs-example"
        defaultActiveKey={activeKey}
        activeKey={activeKey}
        onSelect={handleSelect}
      >
        <Card className="card-chat overflow-hidden">
          <Card.Body as={Flex} className="p-0 h-100">
            <ChatSidebar hideSidebar={hideSidebar} />
            <ChatContent setHideSidebar={setHideSidebar} />
          </Card.Body>
        </Card>
      </Tab.Container>
      <SearchModal selectThread={selectThread} />
      <ReportModal />
    </>
  );
};

const ElvisHistory = () => {
  return (<ChatTab />);
};

export default memo(ElvisHistory);